import React from 'react';

import { useCanvasBackground } from '@/hooks/useCanvasBackground';

/** Null-rendering helper that tints the document canvas while mounted — for
 * views that have no bottom painter of their own (e.g. Help/Settings). */
const CanvasBackground: React.FC<{ color: string | null }> = ({ color }) => {
  useCanvasBackground(color);
  return null;
};

export default CanvasBackground;
